import { getIconBorderColor, getIconColor, getIconContent } from 'utils';

import { useTranslation } from 'react-i18next';

import { ROLES } from 'constants/global';
import { IDBUser } from 'constants/types';

import {
  Container,
  SidebarContainer,
  SidebarHeader,
  StatusIcon,
  UserItem,
  UserName,
  UserRole,
} from './styles';
import { useGetCommunityMembersQuery } from 'oyofrontend/communityManagement';

const RightSidebar = () => {
  const { t } = useTranslation('forum');
  const { data: communityMembers = [] } = useGetCommunityMembersQuery();

  return (
    <SidebarContainer>
      <SidebarHeader>{t('community_members')}</SidebarHeader>
      <Container>
        {communityMembers.map((user: IDBUser, index: number) => (
          <UserItem key={index}>
            <StatusIcon
              color={getIconColor(user.role)}
              borderColor={getIconBorderColor(user.role)}
            >
              {getIconContent(user.role, user.firstName, user.lastName)}
            </StatusIcon>
            <div>
              <UserName>
                {user.firstName} {user.lastName}
              </UserName>
              {user.role &&
                user.role !== ROLES.CONSUMER &&
                user.role !== ROLES.PRODUCER && (
                  <UserRole>{user.role}</UserRole>
                )}
            </div>
          </UserItem>
        ))}
      </Container>
    </SidebarContainer>
  );
};

export default RightSidebar;
